import * as React from 'react';

import {useNavigate} from 'react-router-dom';
import {useEffect} from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {useLocation} from "react-router-dom";
import {selfQuestionnaires} from "../../utils/selfQuestionnaires";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';

const CheckMain = () => {
  const navigate = useNavigate();

  return (

    <Stack direction={'row'} spacing={2} sx={{ overflowX: 'auto', whiteSpace: 'nowrap', p: 1, mt: 1, pb: 2 }}>
    {selfQuestionnaires && selfQuestionnaires.sort(() => Math.random() - 0.5).slice(0, 3).map((item, index) => (
      <Box onClick={() => navigate('../check/SelfStart', {state: {selfQuestionNo: item.no}})} sx={BoxStyle}>
        <Typography sx={BoxTitle}>{item.title}</Typography>
        {/* <Typography sx={BoxText}>{item.desc}</Typography> */}
        <ArrowForwardIcon sx={BoxIcon} />
      </Box>
    ))}

    <Box onClick={() => navigate('../check/SelfCheckList')} sx={BoxStyle}>
      {/* <Typography sx={BoxTitle}>더보기</Typography> */}
      <Typography sx={BoxTitleMore}>자가진단<br/>테스트<br/>더보기</Typography>
      <AddIcon sx={BoxMoreIcon} />
    </Box>
  </Stack>
  );
}


const BoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#fff',
  p: 2,
  borderRadius: 5,
  boxSizing: 'border-box',
  boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)'
}

const BoxTitle = {
  fontSize: '14px',
  color: '#444',
  fontWeight: 700,
  flex: 'auto',
  whiteSpace: 'break-spaces',
  width: 105,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '3',
  WebkitBoxOrient: 'vertical',
}

const BoxTitleMore = {
  fontSize: '14px',
  color: '#ef8322',
  fontWeight: 700,
  flex: 'auto',
  whiteSpace: 'break-spaces',
  width: 105,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '3',
  WebkitBoxOrient: 'vertical',
}



const BoxText = {
  fontSize: '12px',
  color: '#444',
  mt: 1,
  whiteSpace: 'break-spaces',
  width: 150,
  flex: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '3',
  WebkitBoxOrient: 'vertical',

}

const BoxIcon = {
  ml: 'auto',  
  mt: 2,
  bgcolor: '#ffc08a',
  borderRadius: '50%',
  color: '#fff',
  p:'2px',
  fontSize:20
}

const BoxMoreIcon = {
  ml: 'auto',  
  mt: 2,
  bgcolor: '#f99a48',
  borderRadius: '50%',
  color: '#fff',
  p:'2px',
  fontSize:20
}



export default CheckMain;